import { Table } from "@/features/Table";
import { useBulkDeleteControls } from "@/features/Edit/useBulkDeleteControls";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { type N1TimeSerie, columns } from "./columns";
import { type FilterN1TimeSeriesSchema, FilterN1TimeSeries } from "./filter";

const client = Clients.N1;
const table_name = Tables.N1_TIME_SERIES;

export const N1TimeSeriesTable = () => {
  const { selectionActions, modal } = useBulkDeleteControls<N1TimeSerie>({
    client,
    table_name,
    resourceLabel: "Valorisation",
  });

  return (
    <>
      <Table<N1TimeSerie, FilterN1TimeSeriesSchema>
        label="Valorisation"
        client={client}
        table_name={table_name}
        columns={columns}
        filter={<FilterN1TimeSeries />}
        actions={[
          {
            label: "actions.new",
            route: `${client}/${table_name}/new`,
          },
        ]}
        enableRowSelection
        selectionActions={selectionActions}
      />
      {modal}
    </>
  );
};
